/* eslint-disable no-param-reassign */

// export const moneyFormat = (amount: number, lang: string): string =>
//   new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'fr-FR', {
//     style: 'currency',
//     currency: 'CAD',
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 2,
//     currencyDisplay: 'narrowSymbol',
//   }).format(amount);

// export const moneyParse = (price: string): number => {
//   // FR format
//   if (!price?.startsWith('$')) return Number(price?.replace(',', '.').replace(/[^0-9.-]+/g, ''));

//   // EN format
//   return Number(price?.replace(/[^0-9.-]+/g, ''));
// };

/* eslint-disable no-param-reassign */
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatPrice = (price: number): string => {
  return formatter.format(price);
};
